export class cookieUseController {
  
  public constructor(
    private storage: any
  ){}

  public confirm = () => {
    this.storage.state = {...this.storage.state, acceptCookies: 'true'}
  }
}